module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Lichtensteig-c19255b9cfdf35a36c43765f42258a03.svg";